<template>
  <div class="grid-form w-full">
    <div class="col-start-1">
      <BaseShowEditDateTimePickerv2
        v-model:date="localCreatedAt"
        :label-date="$t('attributes.date')"
        :edition-mode="editionMode"
        :disabled="editionMode && !subjectValid"
      />
    </div>
    <div class="col-span-2">
      <RadioCardComponent
        v-model="localDescription"
        :options="filteredActivityLogTypes"
        track-by="id"
        attribute-label="name"
        :disabled="!editionMode || !subjectValid"
      />
    </div>
    <div
      v-if="activityLog.subject_type === 'App\\Models\\Dossier'"
      class="col-span-2"
    >
      <SelectDossier
        v-model:dossier-id="localSubjectId"
        v-model:dossier="localSelectedDossier"
        :disabled="!editionMode"
      />
    </div>
    <div class="col-span-2">
      <BaseShowEditTextArea
        v-model="localNotes"
        :label="$t('attributes.notes')"
        name="description"
        :edition-mode="editionMode"
        :rows="7"
      />
    </div>
    <div
      v-if="
        activityLog.subject_type === 'App\\Models\\Dossier' &&
        activityLog.subject_id
      "
      class="col-span-1"
    >
      <BaseCheckBox
        v-model="localAddToInternalNote"
        name="add_to_internal_note"
        :label="$t('global.add_to_internal_note')"
        :edition-mode="editionMode"
      />
    </div>
    <div v-if="linkedTasks.length" class="col-span-2 flex flex-col gap-2">
      <p
        class="capitalize-first text-sm font-medium text-gray-700 dark:text-gray-200"
      >
        {{ $t('global.tasks') }}
      </p>
      <div class="grid grid-cols-2 gap-2 md:grid-cols-3">
        <div
          v-for="(task, index) in linkedTasks"
          :key="task.id ?? task._uid"
          class="flex items-center gap-1"
        >
          <div
            class="flex-1 cursor-pointer overflow-hidden"
            @click="$emit('open-task', index)"
          >
            <TaskDossierCard
              :task="task"
              :is-item-task="true"
              size="mini"
              :not-editable="true"
            />
          </div>
          <button
            type="button"
            class="flex h-8 w-8 shrink-0 items-center justify-center rounded text-red-400 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/20 dark:hover:text-red-400"
            @click="removeTask(index)"
          >
            <FontAwesomeIcon :icon="['fal', 'trash']" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import RadioCardComponent from '@c/BaseFormComponent/RadioCardComponent.vue'
import SelectDossier from '@c/SelectAjaxComponent/SelectDossier.vue'
import BaseShowEditDateTimePickerv2 from '@c/addf-package/components/BaseShowEditDatePicker/BaseShowEditDateTimePickerv2.vue'
import BaseShowEditTextArea from '@c/addf-package/components/BaseShowEditInput/BaseShowEditTextArea.vue'
import BaseCheckBox from '@c/addf-package/components/BaseCheckBox/BaseCheckBox.vue'
import TaskDossierCard from '@/views/dossier/form/subpages/taskDossier/components/taskDossierList/components/TaskDossierCard.vue'

export default {
  name: 'ActivityLogFormFields',
  components: {
    TaskDossierCard,
    FontAwesomeIcon,
    BaseCheckBox,
    BaseShowEditTextArea,
    BaseShowEditDateTimePickerv2,
    SelectDossier,
    RadioCardComponent
  },
  props: {
    activityLog: {
      type: Object,
      required: true
    },
    filteredActivityLogTypes: {
      type: Array,
      required: true
    },
    selectedDossier: {
      type: Object,
      required: false,
      default: null
    },
    addToInternalNote: {
      type: Boolean,
      required: false,
      default: false
    },
    subjectValid: {
      type: Boolean,
      required: false,
      default: false
    },
    editionMode: {
      type: Boolean,
      required: false,
      default: true
    },
    linkedTasks: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: [
    'update:activityLog',
    'update:selectedDossier',
    'update:addToInternalNote',
    'update:linkedTasks',
    'open-task'
  ],
  computed: {
    localCreatedAt: {
      get() {
        return this.activityLog.created_at
      },
      set(val) {
        this.$emit('update:activityLog', {
          ...this.activityLog,
          created_at: val
        })
      }
    },
    localDescription: {
      get() {
        return this.activityLog.description
      },
      set(val) {
        this.$emit('update:activityLog', {
          ...this.activityLog,
          description: val
        })
      }
    },
    localSubjectId: {
      get() {
        return this.activityLog.subject_id
      },
      set(val) {
        this.$emit('update:activityLog', {
          ...this.activityLog,
          subject_id: val
        })
      }
    },
    localNotes: {
      get() {
        return this.activityLog.properties?.notes
      },
      set(val) {
        this.$emit('update:activityLog', {
          ...this.activityLog,
          properties: { ...this.activityLog.properties, notes: val }
        })
      }
    },
    localSelectedDossier: {
      get() {
        return this.selectedDossier
      },
      set(val) {
        this.$emit('update:selectedDossier', val)
      }
    },
    localAddToInternalNote: {
      get() {
        return this.addToInternalNote
      },
      set(val) {
        this.$emit('update:addToInternalNote', val)
      }
    }
  },
  methods: {
    removeTask(index) {
      this.$emit(
        'update:linkedTasks',
        this.linkedTasks.filter((_, i) => i !== index)
      )
    }
  }
}
</script>
